import { Form, notification } from 'antd';
import { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { BorderedTitle } from '@/components/BorderedTitle';
import { withFeatureFlag } from '@/components/FeatureFlag/FeatureFlag';
import { LoginCard, LoginFormItem, LoginSubmit } from '@/components/Login';
import PasswordRequirements from '@/components/PasswordRequirements';
import {
  createPasswordOnChangeHandler,
  getPasswordConfirmationRules,
  getPasswordRules,
} from '@/components/PasswordRequirements/passwordValidation';
import Session from '@/services/Session';
import { resetPassword } from '@/services/api';

import OldResetPassword from './deprecated/OldResetPassword';

class ResetPassword extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.deprecated_checkSession();
  }

  handleSuccess = () => {
    this.setState({
      redirectTo: '/success',
      loading: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;

    if (this.state.loading) {
      return;
    }

    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        this.setState({
          loading: false,
        });
        return;
      }

      this.setState({
        loading: true,
      });

      try {
        await resetPassword(Session.signature(), values);
        this.handleSuccess();
      } catch (error) {
        const { response } = error;
        const { form } = this.props;

        // Display field-specific errors
        const hasFieldErrors = response?.errors?.some((res) => res.id);
        if (response?.errors) {
          response.errors.forEach((res) => {
            if (res.id) {
              form.setFields({
                [res.id]: {
                  value: values[res.id] || form.getFieldValue(res.id),
                  errors: [new Error(res.detail)],
                },
              });
            }
          });
        }

        // Don't show notification for field-specific validation errors
        const generalError =
          response?.errors?.find((res) => !res.id)?.detail ||
          (!hasFieldErrors && (response?.error || error.message));

        if (generalError) {
          notification.error({ message: 'Error', description: String(generalError) });
        }

        this.setState({ loading: false });
      }
    });
  };

  // TODO: Remove
  deprecated_checkSession = async () => {
    const {
      history,
      location: { search },
    } = this.props;
    const searchParams = new URLSearchParams(search);
    const signature = searchParams.get('id');

    if (signature) {
      history.replace(`/relay?signature=${signature}&action=reset_password`);
    }
  };

  renderFormItems = () => {
    const {
      form: { getFieldDecorator, getFieldValue },
      form,
    } = this.props;

    const passwordRules = getPasswordRules();
    const passwordConfirmationRules = getPasswordConfirmationRules(getFieldValue);
    const passwordOnChange = createPasswordOnChangeHandler(form, 'password_confirmation');

    const formItems = [
      {
        name: 'password',
        rules: passwordRules,
        icon: 'lock',
        label: 'New Password',
        placeholder: 'Your new Password',
        type: 'password',
        validateFirst: true,
        decoratorOptions: {
          onChange: passwordOnChange,
        },
      },
      {
        name: 'password_confirmation',
        rules: passwordConfirmationRules,
        icon: 'lock',
        label: 'New Password Confirmation',
        placeholder: 'Confirm your new password',
        type: 'password',
        validateFirst: true,
      },
    ];

    return formItems.map((itemProps, index) => (
      <LoginFormItem
        {...itemProps}
        key={itemProps.name}
        getFieldDecorator={getFieldDecorator}
        autoFocus={index === 0}
      />
    ));
  };

  render() {
    if (!Session.valid()) {
      return <Redirect to="/error" />;
    }

    const { redirectTo } = this.state;

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    const { user } = Session.get();

    return (
      <LoginCard title="Enter a New Password">
        <BorderedTitle>{user.email}</BorderedTitle>
        <Form onSubmit={this.handleSubmit}>
          {this.renderFormItems()}
          <PasswordRequirements />
          <LoginSubmit loading={this.state.loading}>Reset Password</LoginSubmit>
        </Form>
      </LoginCard>
    );
  }
}

export default Form.create()(
  withFeatureFlag('ketKeet3316RiskPasswordRemediation', ResetPassword, OldResetPassword),
);
